var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-wrap"},[_c('layout-header'),_c('div',{staticClass:"layout-main"},[_c('transition',{attrs:{"name":"fade-move","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }